import { render, staticRenderFns } from "./NoCertainItemsCustomer.vue?vue&type=template&id=01eabf89&scoped=true"
import script from "./NoCertainItemsCustomer.vue?vue&type=script&lang=js"
export * from "./NoCertainItemsCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01eabf89",
  null
  
)

export default component.exports